"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onClickErrorModalClose = onClickErrorModalClose;
exports.onProviderSignupFieldChange = onProviderSignupFieldChange;
exports.submitProviderSignupForm = submitProviderSignupForm;

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _NabiscoApp = _interopRequireDefault(require("Nabisco.app.AppCookieLogin"));

var _Raven = _interopRequireDefault(require("Raven"));

var _SignupClient = _interopRequireDefault(require("../data/SignupClient"));

var _env = require("../utils/env");

var appCookieLogin = new _NabiscoApp.default();

function onClickErrorModalClose() {
  return {
    type: _ActionTypes.default.DISMISSED_PROVIDER_SIGNUP_ERROR
  };
}

function onProviderSignupFieldChange(field, inputText) {
  return {
    type: _ActionTypes.default.PROVIDER_SIGNUP_FIELD_CHANGED,
    payload: {
      field: field,
      inputText: inputText
    }
  };
}

function _submitProviderSignupForm(error) {
  if (error) {
    return {
      type: _ActionTypes.default.PROVIDER_SIGNUP_FORM_SUBMITTED,
      payload: error,
      error: true
    };
  }

  return {
    type: _ActionTypes.default.PROVIDER_SIGNUP_FORM_SUBMITTED
  };
}

function redirectToProfilePage(portalId) {
  window.location = "https://app.hubspot" + ((0, _env.isProd)() ? '' : 'qa') + ".com/providers/" + portalId + "/profile";
}

function submitProviderSignupForm() {
  return function (dispatch, getState) {
    dispatch(_submitProviderSignupForm());

    _SignupClient.default.submitProviderSignupForm(getState().providerSignup).then(function (signupResp) {
      if (signupResp.hubId && !signupResp.userCreated) {
        redirectToProfilePage(signupResp.hubId);
      } else if (signupResp.hubId) {
        appCookieLogin.login({
          email: getState().providerSignup.get('contactEmail'),
          password: getState().providerSignup.get('password')
        }).then(function () {
          redirectToProfilePage(signupResp.hubId);
        }, function () {
          _Raven.default.captureMessage('call to nabisco service returned error');

          redirectToProfilePage(signupResp.hubId);
        }).done();
      } else {
        _Raven.default.captureMessage('error signing up provider: no portalId');
      }
    }, function (error) {
      var errorObj = JSON.parse(error.data);

      if (errorObj && errorObj.message) {
        dispatch(_submitProviderSignupForm(errorObj));
        return;
      } // Do not hang in the event an error occurs and we do not know why


      dispatch(_submitProviderSignupForm({
        message: 'unknown'
      }));

      _Raven.default.captureMessage('unknown error signing up provider');
    });
  };
}